import { Component, EventEmitter, Output } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { NavigationItem } from './types';
import { UtilsService } from '../../services/utils.service';
import { ICONS } from '../../constants/constants';

@Component({
  selector: 'app-desktop-navigation-dropdown',
  templateUrl: './desktop-navigation-dropdown.component.html',
  styleUrls: ['./desktop-navigation-dropdown.component.scss'],
})
export class DesktopNavigationDropdownComponent {
  protected readonly ICONS = ICONS;

  @Output() closeDropdown: EventEmitter<void> = new EventEmitter<void>();
  @Output() logout: EventEmitter<void> = new EventEmitter<void>();

  constructor(public authService: AuthService) {}

  get navigationItems(): NavigationItem[] {
    return UtilsService.getNavigationItems(this.authService);
  }

  onCloseDropdown(): void {
    this.closeDropdown.emit();
  }

  onLogout(): void {
    this.logout.emit();
    this.onCloseDropdown();
  }
}
